import HeaderCart from "../common/headerCart";
import { urlencodeFormData } from "./utilities";

const Store = {
  config: {
    priceProds: {
      selector: '[data-update-price]',
      attr: 'update-price',
    },
    cartCount: {
      selector: '[data-cart-count]',
      attr: '[data-cart-count-attr]',
      text: '[data-cart-item-text]'
    },
  },
  addProduct: function(form, parent, callback) {

    // Tratativa para bundle nativo
    if (form.hasAttribute('data-bundle-section')) {
      Store.addBundle(form, parent)
      return
    }

    // Se tiver customizações, ajusta campos de texto que não foram preenchidos
    const customizations = form.querySelectorAll('[data-customization]')
    const quantity = Number(form.querySelector('[name="quantity"]').value)
    if (customizations.length > 0) customizations.forEach(custom => {
      const type = custom.getAttribute('type')

      if (type !== 'checkbox' || type !== 'radio') {
        if (custom.value === '') {
          custom.setAttribute('disabled', true)
        }
      }
    })

    // Item com assinatura
    if (Store.useSubscription && form.hasAttribute('data-product-subscription')) {
      Store.addSubscription(form, parent)
    } else {
      if (customizations.length > 0 && quantity > 1) {
        // Item com personalização e com quantidade alta
        Store.addItemsCustom(form, parent, callback)
      } else {
        // Item com quantidade 1, com ou sem personalização
        Store.addItem(form, parent, callback)
      }
    }
  },

  addBundle: async function (form, parent) {
    let bundle_skus = []
    
    const bundleProducts = form.querySelectorAll('[data-product-box]');
    bundleProducts.forEach(product => {
      bundle_skus.push(product.querySelector('[name="sku"]').value)
    })

    const bundleObj = {
      sku: document.querySelector('[data-main-bundle-product-id]').value,
      quantity: 1,
      bundle_skus
    }

    let formBody = [];
    for (const key in bundleObj) {
      if (bundleObj.hasOwnProperty(key)) {
        const value = bundleObj[key];

        // Lida com a array de bundle_skus
        if (key === 'bundle_skus' && Array.isArray(value)) {
          value.forEach(item => {
            formBody.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
          });
        } else {
          // Lida com as demais propriedades que não são array
          const encodedValue = Array.isArray(value) ? value.map(item => encodeURIComponent(item)).join(',') : encodeURIComponent(value);
          formBody.push(`${encodeURIComponent(key)}=${encodedValue}`);
        }
      }
    }

    formBody = formBody.join('&');

    try {
      while (true) {
        const response = await fetch('/carrinho/adicionar', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json, text/javascript, */*; q=0.01',
          },
          body: formBody,
        });

        if (response.status === 202) {
          const retryAfter = response.headers.get('Retry-After');
          const delay = retryAfter ? parseInt(retryAfter, 10) : 3000; // Default 3s se não houver Retry-After
          console.info(`Tentando novamente em ${delay} ms...`);
          await new Promise((resolve) => setTimeout(resolve, delay));
        } else {

          if (!response.ok) {
            const text = await response.text()
            console.error('addBundle - Erro na requisição de adição de produto.')
            console.error(response)
            console.error(text)

            const button = form.querySelector('[data-bundle-add]');
            if (button) {
              button.classList.add('-unavailable')

              const innerHTML = button.innerHTML
              button.innerHTML = 'Erro ao adicionar no carrinho'

              setTimeout(() => {
                button.classList.remove('-unavailable')
                button.innerHTML = innerHTML
              }, 2000)
            }

            return
          }

          const data = await response.json();
          console.log('addBundle - success', data);

          HeaderCart.loadCart()
          HeaderCart.show()
          break;
        }
      }
    } catch (error) {
      console.log('addBundle - error');
      console.log(error)

      const button = form.querySelector('[data-bundle-add]');
      if (button) {
        button.classList.add('-unavailable')

        const innerHTML = button.innerHTML
        button.innerHTML = 'Erro ao adicionar no carrinho'

        setTimeout(() => {
          button.classList.remove('-unavailable')
          button.innerHTML = innerHTML
        }, 2000)
      }
    }
  },
  addItemResult: function (typeResult, result, boxResponse, form) {
    const _this = this;

    if (typeResult == 'produto-adicionado') {
      const btnComprar = form.querySelector('[data-action="add-cart"]');

      if (btnComprar) btnComprar.classList.add('success');

      setTimeout(function () {
        if (btnComprar) btnComprar.classList.remove('success');
        if (btnComprar) btnComprar.innerHTML = btnComprar.dataset.textAvailable;
      }, 3500);

      HeaderCart.loadCart()
      HeaderCart.show()

      // Verifica se há popup de compra rápida ativo. Se tiver, fecha ele
      // Retirar ou comentar se não for utilizado
      const popupQuickview = document.querySelectorAll('[data-popup-quickview]');
      popupQuickview.length > 0 && popupQuickview.forEach(popup => {
        if (popup.classList.contains('-active')) {
          popup.querySelector('[data-close-popup-quickview]').click();
        }
      })

      // Remove disabled das personalizações de texto, se existirem
      const customizations = form.querySelectorAll('[data-customization]')
      if (customizations.length > 0) customizations.forEach(custom => {
        const type = custom.getAttribute('type')
        if (type !== 'checkbox' || type !== 'radio') {
          custom.removeAttribute('disabled')
        }
      })
      
    } else if (typeResult == 'erro-adicionar') {
      if (typeof boxResponse != 'undefined' && boxResponse.length > 0) {
        window.scrollTo({
          top: boxResponse.offsetTop,
          behavior: 'smooth',
        });

        boxResponse.classList.add('error');
        boxResponse.classList.remove('success');
        boxResponse.querySelector('span').innerHTML =
          'Ocorreu um erro, tente novamente.';
      }
    }
  },
  addItemResultDefault: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuy);

      $btnComprar.addClass('success').html('Produto adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlCart;
      }, 150);

    } else if (_typeResult == 'erro-adicionar') {
      var errorText = JSON.parse(_result.responseText);

      if (typeof(_$boxResponse) != 'undefined' && _$boxResponse.length > 0) {
        //console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  addItemResultDefaultAssinatura: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuyAssinatura);

      $btnComprar.addClass('success').html('Adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlAssinaturaCart;
      }, 150);

    } else if (_typeResult == 'erro-adicionar') {
      if (typeof _result == 'object') {
        var errorText = _result;
      } else {
        var errorText = JSON.parse(_result);
      }

      if (typeof (_$boxResponse) != 'undefined' && _$boxResponse.length > 0) {
        //console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);
      }
    }
  },
  addItem: async function (form, parent, callback) {
    const _this = this;
    const btnComprar = parent.querySelector('[data-action="add-cart"]');
    const urlAdd = '/carrinho/adicionar';
    const formData = urlencodeFormData(new FormData(form));
    const boxResponse = parent.querySelector('[data-form-product] .msg-response:not(.resp-validate)');

    console.info('addItem');

    if (!btnComprar.classList.contains('-adding')) {
      btnComprar.classList.add('-adding');

      try {
        while (true) {
          const response = await fetch(urlAdd, {
            method: 'POST',
            headers: {
              'Accept': 'application/json, text/javascript, */*; q=0.0',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: formData,
          });
  
          if (response.status === 202) {
            const retryAfter = response.headers.get('Retry-After');
            const delay = retryAfter ? parseInt(retryAfter, 10) : 3000; // Default 3s se não houver Retry-After
            console.info(`Tentando novamente em ${delay} ms...`);
            await new Promise((resolve) => setTimeout(resolve, delay));
          } else {

            if (!response.ok) {
              const text = await response.text()
              console.error('addItem - Erro na requisição de adição de produto.')
              console.error(response)
              console.error(text)
              return
            }

            const data = await response.json();
            console.log('addItem - success', data);
  
            if (typeof callback === 'function') {
              callback('produto-adicionado', data, boxResponse, form);
            } else {
              _this.addItemResult('produto-adicionado', data, boxResponse, form);
            }
            break;
          }
        }
      } catch (error) {
        console.log('addItem - error');
        console.error(error);
  
        if (typeof callback === 'function') {
          callback('erro-adicionar', error, boxResponse, form);
        } else {
          _this.addItemResult('erro-adicionar', error, boxResponse, form);
        }
      }

      btnComprar.classList.remove('-adding');
    }
  },
  deleteItem: function (_itemId, _$item, removeItemResult) {
    var _this = this;

    if (!_$item.hasClass('removing')) {
      $.ajax({
        url: '/carrinho',
        type: 'POST',
        dataType: 'json',
        data: {
          '_method': 'delete',
          'item_id': _itemId
        },
        beforeSend: function () {
          _$item.addClass('removing');
        }
      })
      .done(function(_cart) {
        //console.log("success");
        HeaderCart.loadCart(_cart);

        if (typeof removeItemResult == 'function') {
          removeItemResult(_$item, _cart);
        }
      })
      .fail(function(error) {
        //console.log("erro ao remover", error.responseText);
      })
      .always(function() {
        _$item.removeClass('removing');
      });
    }
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;
    
    $('.action.-cart .count').removeClass('hidden');
    $(_this.config.cartCount.attr).data('cart-count-attr', _itemsCount);
    $(_this.config.cartCount.attr).attr('data-cart-count-attr', _itemsCount);

    if (_itemsCount) {
      if (_itemsCount.items_count > 0) {
        $('.action.-cart .count').removeClass('hidden');
        $(_this.config.cartCount.attr).html(_itemsCount.items_count);
        $(_this.config.cartCount.text).html(_itemsCount.items_count);
      } else {
        $(_this.config.cartCount.attr).html(0);
        $(_this.config.cartCount.text).html(0);
      }
  
      if (_itemsCount > 0) {
        $('[data-cart-body]').parent().addClass('active');
      } else {
        $('[data-cart-body]').parent().removeClass('active');
      }
    }
  },
  getCartCount: function () {
    async function getCartItens () {
      let itens;

      try {
        itens = await $.ajax({
          url: '/carrinho/itens', 
          type: 'GET', 
          dataType: 'text'
        });

        return itens;
      } catch (error) {
        console.error(error);
      }
    }

    if ($(Store.config.cartCount.selector).length > 0) {
      getCartItens().then((total) => {
        var itens = Number.isInteger(parseInt(total));
        if (itens) {
          $(Store.config.cartCount.attr).attr('data-cart-count-attr', total);
          $(Store.config.cartCount.selector).html(total);
  
          var $boxCart = $('[data-cart-body]');
  
          if ($boxCart.length > 0) {
            if (total > 0) {
              HeaderCart.loadCart();
            } else {
            
            }
          }
        }
      });
    };
  },
  getPriceProd: function () {
    var selector = Store.config.priceProds.selector;
    var attr = Store.config.priceProds.attr;

    if ($(selector).length > 0) {
      $(selector).each(function(index, value) {
        var $this = $(this);
        var prodId = $(this).data(attr);
        var url = '/produto/preco/' + prodId;

        if(prodId != '' && prodId != null) {
          $.ajax({
            url: url,
            type: 'GET',
          })
          .done(function(resp) {
            // console.info(resp);
            $this.html(resp);
            $this.parent().parent().parent().addClass('price-prod');
          })
          .fail(function(resp) {
            console.error(resp);
          });
        }
      });
    }
  },
  validateFormProduct: function (form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var btnComprar = form.querySelector('[data-action="add-cart"]');
    var validated = true;
    var errors = [];

    if (btnComprar.dataset?.available == 'false') {
      validated = false;
      errors.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (form.querySelector('[name="sku"]').value == '') {
        validated = false;
        errors.push('Selecione um atributo para o produto');
      }

      //  verifica se a quantidade é válida
      if (form.querySelector('input[name="quantity"]').value <= 0) {
        validated = false;
        errors.push('Quantidade indisponível');
      }
    }

    return { validated, errors };
  },
}

export default Store
